// src/contexts/LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    // Home/Landing Page
    companyName: 'Transport Transit Service',
    companyNameShort: 'TTS',
    home: 'Home',
    heroTitle: 'Transport Registration & Insurance Services',
    heroSubtitle: 'Streamline your cross-border transportation with our comprehensive registration and insurance services. We specialize in providing efficient solutions for all vehicle types heading to Georgia.',
    learnMore: 'Learn More',
    getInsurance: 'Get Insurance',
    ourServices: 'Our Services',
    servicesSubtitle: 'Our platform offers integrated solutions designed specifically for transport companies and individual drivers crossing international borders (Georgia, Russia). With our expert guidance and efficient digital tools, we help you navigate complex regulations with ease.',
    registrationService: 'Vehicle Registration',
    registrationServiceDesc: 'Our streamlined registration process allows you to purchase Georgian Road Transit Cards online and pay for parking fees in the Dariali Gorge for trucks.',
    insuranceService: 'Vehicle Insurance',
    insuranceServiceDesc: "Through our online platform obtain mandatory liability insurance from Georgia's Compulsory Insurance Center. By arranging your insurance in advance, you avoid border crossing queues and unnecessary time loss.",
    documentationService: 'Documentation',
    documentationServiceDesc: "Overcome the complexities of obtaining mandatory transit permits, certificates, and authorizations for cross-border freight transportation using our online platform's tools. Our experts will help you quickly navigate the field.",
    readMore: 'Read More',
    insuranceTitle: 'Travel with Confidence',
    insuranceHighlightDesc: "When traveling to Georgia, having proper insurance isn't just a recommendation—it's a requirement. We offer to arrange a mandatory vehicle insurance polis complieing with all Georgian regulations, ensuring your journey proceeds without legal complications.",
    insuranceBenefit1: 'Instant digital policy issuance—receive your documents immediately via email (which you are required to print and submit upon request)',
    insuranceBenefit2: 'Recognized by all Georgian authorities and border checkpoints',
    insuranceBenefit3: 'Multilingual support team available for assistance with claims or questions',
    getInsuranceNow: 'Get Insurance Now',
    registrationsCompleted: 'Registrations completed',
    insurancePoliciesIssued: 'Insurance policies issued',
    satisfactionRate: 'Customer satisfaction',
    supportAvailable: 'Support available',
    contactCTA: 'Need Help?',
    contactCTADesc: 'Our support team is ready to assist you with any questions',
    OurClients: 'What Our Clients Say',
    Client1: '— Maria K., Logistics Manager',
    Client2: '— David T., Transport Company Owner',
    Client1Com: '"TTS has revolutionized our cross-border operations. Their efficient registration system and quick insurance processing have saved us countless hours and prevented delays at border crossings."',
    Client2Com: '"The support is exceptional. When we had an issue at the Georgian Darial parking terminal, their team resolved it within minutes."',
    
    //PublicNavbar
    insuranceAM: 'Armenia',
    insuranceGE: 'Georgia',
    insuranceRU: 'Russia',
    
    //PublicLayout
    servicesShortDesc: 'We provide comprehensive services for vehicles.',
    LayoutServices: 'Services',
    LayoutRegistration: 'Registration',
    LayoutInsurance: 'Insurance',
    LayoutDocumentation: 'Documentation',
    LayoutConsultation: 'Consultation',
    LayoutSupport: 'Support',
    LayoutHelp: 'Help Center',
    LayoutCont: 'Contact Us',
    LayoutFAQ: 'FAQ',
    LayoutTerms: 'Terms of Service',
    LayoutContact: 'Contact',
    LayoutAddress1: 'Yerevan,',
    LayoutAddress2: 'Armenia',
    LayoutPrivacy: 'Privacy',
    LayoutTerm: 'Terms',
    
    // Insurance Page
    vehicleInsurance: 'Vehicle Insurance',
    vehicleInsuranceForGeorgia: 'Vehicle Insurance for Georgia Travel',
    insurancePageSubtitle: 'Mandatory insurance for all vehicles entering Georgia with quick online registration',
    insuranceFormSubtitle: 'Get your policy in just a few minutes',
    duration: 'Insurance Duration',
    vehicleType: 'Vehicle Type',
    days: 'days',
	days_15: '15 Days',
    days_30: '30 Days',
    days_90: '90 Days',
	year_1: '1 year',
    year: '1 year',
    motorcycle: 'Motorcycle',
    passengerCar: 'Passenger Car',
    bus: 'Bus',
    truck: 'Truck',
    trailer: 'Trailer',
    specialVehicle: 'Special Vehicle',
    insuranceCoverage: 'Coverage Details',
    insuranceCoverageDesc: 'This insurance provides third-party liability coverage as required by Georgian law',
    estimatedPrice: 'estimated price',
    manufacturer: 'Manufacturer',
    model: 'Model',
    registrationNumber: 'Registration Number',
    vinCode: 'VIN Code',
    frameNumber: 'Frame Number',
    personalDetails: 'Personal Details',
    firstName: 'First Name',
    lastName: 'Last Name',
    name: 'Name',
    idNumber: 'ID Number',
    email: 'Email',
    review: 'Review & Payment',
    totalPrice: 'Total Price',
    cardPayment: 'Credit/Debit Card',
    processing: 'Processing...',
    submitApplication: 'Submit Application',
    allRightsReserved: 'All Rights Reserved',
    pleaseEnterCredentials: 'Please enter your username and password',

    // Insurance Benefits and FAQ
    benefits: 'Benefits',
    completeProtection: 'Complete Protection',
    completeProtectionDesc: 'Coverage for all liability requirements in Georgia',
    easyApplication: 'Easy Application',
    easyApplicationDesc: 'Simple online process with minimal documentation',
    quickProcessing: 'Quick Processing',
    quickProcessingDesc: 'Get your insurance policy in just minutes',
    georgiaWideAcceptance: 'Georgia-wide Acceptance',
    georgiaWideAcceptanceDesc: 'Valid at all border crossings and accepted nationwide',
    faq: 'Frequently Asked Questions',
    faqCoverage: 'What does the insurance cover?',
    faqCoverageAnswer: 'Our insurance provides third-party liability coverage as required by Georgian law for vehicles entering the country.',
    faqDocuments: 'What documents do I need to apply?',
    faqDocumentsAnswer: 'You\'ll need your vehicle registration certificate, identification document, and basic vehicle details.',
    faqDuration: 'Can I extend my insurance period?',
    faqDurationAnswer: 'Yes, you can extend your insurance by applying for a new policy before the current one expires.',
    faqProcessing: 'How long does it take to process my application?',
    faqProcessingAnswer: 'Most applications are processed immediately, and you\'ll receive your policy via email within minutes.',
    insuranceDetailsInfo: 'Insurance provides protection for your vehicle when crossing international borders. Having valid insurance is mandatory when entering Georgia.',
    editRegistration: 'Edit Registration',
    update: 'Update',

    // Auth
    login: 'Login',
    username: 'Username',
    password: 'Password',
    rememberMe: 'Remember Me',
    invalidCredentials: 'Invalid credentials',
    loginFailed: 'Login failed. Please try again.',

    // Navigation
    registrations: 'Registrations',
    invoices: 'Invoices',
	vehicleFleet: 'Vehicle fleet',
    technicalConsultation: 'Technical Consultation',
    logout: 'Logout',
    dashboard: 'Dashboard',

    // Registration Form
    register: 'Register',
    exportExcel: 'Export Excel',
    export: 'Export',
    distribute: 'Distribute',
    exportToAccounting: 'Export to accounting',
    chooseExportType: 'Choose export type',
    extendedExport: 'Extended export',
    extendedExportDesc: 'Monthly registrations + insurance + invoice.',
    monthly: 'Monthly',
    selectMonth: 'Month',
    selectPlaceholder: '— select —',
    noAvailableMonths: 'No months available yet.',
    noDataMonth: 'no data',
    loadingEllipsis: 'Loading…',
    accUnavailAlready: 'Accounting export unavailable: already exported for this month.',
    accUnavailPartly: 'Accounting export unavailable: month already partly finalized.',
    vehicleDetails: 'Vehicle Details',
    routeDetails: 'Route Details',
    truckNumber: 'Truck Number',
    company: 'Company',
    phone: 'Phone',
    ticket: 'Ticket',
    entryPoint: 'Entry Point',
    exitPoint: 'Exit Point',
    transitIn: 'Transit Card',
    transitOut: 'Transit Out',
    transit: 'Transit',
    status: 'Status',
    insurance: 'Vehicle Insurance',
    departureDate: 'Departure Date',
    terminalEntryDate: 'Terminal Entry Date',
	terminalExitDate: 'Terminal Exit Date',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    search: 'Search',
    reset: 'Reset',
	murphy: 'Kazbegi',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No',
    select: 'Select',
    nextStep: 'Next Step',
    previousStep: 'Previous Step',
    filters: 'Filters',
	all: 'All',
	searchFilters: 'Search filters',
	no_need: 'No need',
	on_road: 'On road',
	selectEntryExitPoints: 'Select entry and exit points',
	selectEntryPoint: 'Select entry point',
	selectExitPoint: 'Select exit point',
	fillNumber: 'Fill vehicle number',
	totalTransitRemain: 'Transit cards',
	parkDaryalRemain: 'Daryal parking',
	parkBagrGogremain: 'Bagratashen,Gogavan parkings',
	truckInsuranceremain: 'Truck insurance',
	trailerInsuranceremain: '(Semi)Trailer insurance',
	registrationsremain: 'Remainings',
	IN: 'Offered',
	OUT: 'Issued',
	Total: 'Total',
	transitIn_All: 'Offered Transit cards',
	transitOut_All: 'Issued Transit cards',
	truck_insurance_All: 'Trucks insurance',
	trailer_insurance_All: '(Semi)Trailers insurance',
	parking_40_All: 'Natakhtari parking',
	parking_entry_All: 'Daryal parking',
	parking_exit_All: 'Bagratashen,Gogavan parkings',
	
	
    // Table
    registrationList: 'Registration List',
    totalRecords: 'Total records',
    actions: 'Actions',
	transitAndComments: 'Transit Cards',
	totalRegistrations: 'Total registrations',
	transitInOut: 'Transit Cards',
	refresh: 'Refresh',

    // Status Options
    onRoad: 'On Road',
    completed: 'Completed',
    cancelled: 'Cancelled',
    
    // Contact/Consultation Page
    contactUs: 'Contact Us',
    howWeCanHelp: 'How We Can Help You',
    helpRegistration: 'Registration assistance for transport vehicles',
    helpBorderCrossing: 'Technical consultation on border crossing procedures',
    helpDocumentation: 'Help with required documentation and permits',
    helpLegalRequirements: 'Information about legal requirements and regulations',
    helpTechnicalIssues: 'Support for technical issues with the registration system',
    messagingApps: 'Messaging Apps',
    
    // Service Types
    truckInsurance: 'Vehicle Insurance',
    trailerInsurance: '(Semi)Trailer Insurance',
    tirPark: 'TIR-PARK',
    service: 'Service',
	trailerNumber: '(Semi)Trailer number)',
	comment: 'Comment',
	driverInfo: 'Driver',
	routeInfo: 'Direction',
	statusAndDate: 'Status and Date',
	daryal: 'Darial Gorge',
	bagratashen: 'Sadakhlo',
	gogavan: 'Guguti',
	parking_40: 'Natakhtari parking',
    parking_80: 'Border parkings (80 GEL)',
    // Status Types
    pending: 'Pending',
	paid: 'Paid',
	unpaid: 'Unpaid',
    confirmed: 'Confirmed',
    active: 'Active',
    error: 'Error',

    noRegistrationsFound: 'No registrations found',
    confirmDelete: 'Are you sure you want to delete?',
    fieldRequired: 'This field is required',
        // Invoices Page
    addInvoice: 'Add Invoice',
    editInvoice: 'Edit Invoice',
    viewInvoice: 'View Invoice',
    invoiceId: 'Invoice ID',
    serviceType: 'Service Type',
    transitCard: 'Transit Card',
    quantity: 'Quantity',
    price: 'Price',
    totalAmount: 'Total amount including VAT (AMD)',
    paymentType: 'Payment Type',
    cash: 'Cash',
    bankTransfer: 'Bank Transfer',
    card: 'Card',
    attachFile: 'Attach File',
    selectFile: 'Select File',
    changeFile: 'Change File',
    downloadFile: 'Download File',
    noFilesAttached: 'No files attached',
    markAsPaid: 'Mark as Paid',
    paidTotal: 'Paid Total',
    unpaidTotal: 'Unpaid Total',
    totalInvoices: 'Total Invoices',
    transactions: 'Transactions',
    noTransactions: 'No transactions found',
    amount: 'Amount',
    saveFailed: 'Failed to save invoice',
    deleteFailed: 'Failed to delete invoice',
    noInvoicesFound: 'No invoices found',
	totalPaid: 'Total paid',
	totalUnpaid: 'Unpaid',
	exchangeRates: 'Exchange rates',
	lastUpdated: 'Last updated',
	invoicesList: 'Invoices list',
	invoiceNumber: 'Number',
	date: 'Date',
	payment: 'Payment',
	paidServiceQuantities: 'Total quantity of paid services',
	activePaidTotal: 'Total paid',
	activeUnpaidTotal: 'Total unpaid',
	serviceDetails: 'Service details',
	enter_quantity: 'Enter quantity',
	commission: 'Commission',
	paymentInformation: 'Payment information',
	attachment: 'Attach file',
	dragAndDropFile: 'Drag and drop file',
	browseFiles: 'Browse file',
	or: 'or',
	transactionsWillAppearHere: 'Transactions will appear here',
	transactionsDescription: 'Transactions description',
	totalAmountGEL: 'Total amount (GEL)',
	required: 'Required',
	pleaseFixErrors: 'Fill in the required fields',
	fixedPriceService: 'Fixed price service',
	view: 'View',
	invoiceNotPendingNoEdit: 'Editing is possible in the pending status',
	invoiceNotPendingNoDelete: 'Deleting is possible in the pending status',
	close: 'Close',
	download: 'Download',
	invoiceUpdated: 'Updated',
	invoiceCreated: 'Created',
	saveInvoiceError: 'Save error',
	confirmDeleteInvoice: 'Confirm delete',
	deleteInvoiceError: 'Delete error',
	fetchInvoiceError: 'Fetch invoice error',
	paymentStatus: 'Payment status',
	exportSuccess: 'Export success',
	exportFailed: 'Export failed',
	Registration_updated: 'Registration updated',
	Registration_created: 'Registration created',
	Registration_failed: 'Registration failed',

    // Admin registrations
    basicInfo: 'Basic Information',
    statusPoints: 'Status & Points',
    parkingsEntryExit: 'Parkings Entry & Exit',
    transitInfo: 'Transit Information',
    exitPointEntryDate: 'Exit Point Entry Date',
    exitPointExitDate: 'Exit Point Exit Date',
    natakhtariEntryDate: 'Natakhtari Entry Date',
    natakhtariExitDate: 'Natakhtari Exit Date',
    bulkCreate: 'Bulk Create',
    syncFromSite: 'Sync',
    syncing: 'Syncing...',
    markCompleted: 'Mark as Completed',
    markCancelled: 'Mark as Cancelled',
    noVehiclesFound: 'No vehicles in fleet',
    selectVehicleFirst: 'Select a vehicle to enable the rest of the form.',
    vehicleNotInFleet: 'This vehicle is not in the fleet',
    insurancePeriods: 'Insurance Periods',

    // Notification-related translations
  notifications: 'Notifications',
  selected: 'selected',
  selectAll: 'Select all',
  clearSelection: 'Clear selection',
  markAsRead: 'Mark as read',
  markAllAsRead: 'Mark all as read',
  bulkMarkAsRead: 'Mark selected as read',
  bulkDelete: 'Delete selected',
  confirmBulkDelete: 'Are you sure you want to delete the selected notifications?',
  noNotifications: 'No notifications',
  notificationsWillAppearHere: 'Notifications will appear here',
  justNow: 'Just now',
  ago: 'ago',
  loadMore: 'Load more',
  
  // System notification translations
  registrationCreated: 'Registration Created',
  registrationUpdated: 'Registration Updated', 
  registrationDeleted: 'Registration Deleted',
  registrationCreatedMsg: 'Registration for vehicle {number} has been created successfully',
  registrationUpdatedMsg: 'Registration details for vehicle {number} have been updated',
  registrationDeletedMsg: 'Registration for vehicle {number} has been deleted',
  
  invoiceCreated: 'Invoice Created',
  invoiceUpdated: 'Invoice Updated',
  invoiceDeleted: 'Invoice Deleted',
  invoicePaid: 'Invoice Paid',
  invoiceCreatedMsg: 'Invoice {invoiceNumber} for {company} has been created',
  invoiceUpdatedMsg: 'Invoice {invoiceNumber} details have been updated',
  invoiceDeletedMsg: 'Invoice {invoiceNumber} has been deleted',
  
  transactionAdded: 'Transaction Added',
  
  insurance_signed: 'Insurance signed',
  insurance_signedMsg: 'For vehicle {plate_number} insurance signed',
  insurance_expires: 'Insurance expiry date reminder',
  insurance_expiresMsg: 'Insurance for {plate_number} expires {expireDays}.',
  today: 'today',
  tomorrow: 'tomorrow',
  notifDays: 'days',
  

  // In the 'en' translations object, add:
  queueToRussia: 'Electronic queue',
  queueToRussiaDescription: 'Real-time information on vehicle queues at the Verkhniy Lars checkpoint in Russia.',
  queueInformation: 'Queue Information',
  queueInfoTitle: 'Border Queue Status',
  queueInfoDescription: 'Current queue information at the Georgian-Russian border',
  autoRefreshInfo: 'Auto-refresh',
  minutes: 'minutes',
  totalVehicles: 'Total Vehicles',
  licensePlate: 'License Plate',
  location: 'Location',
  datetime: 'Date & Time',
  number: 'Number',
  dataSource: 'Data Source',
  noQueueData: 'No Queue Data Available',
  noQueueDataDescription: 'Queue information is currently unavailable. Please try refreshing or check back later.',
  fetchingQueueData: 'Fetching queue data...',
  failedToFetchQueueData: 'Failed to fetch queue data. Please try again later.',
  georgianRussianBorder: 'Georgian-Russian Border',
  queueUnavailable: 'Queue information temporarily unavailable',
  timeToDelete: 'Time to Delete',
  actions: 'Actions',

    // Add these to the 'en' translations object:
  realTimeQueueInfo: 'Real-time information about vehicle queues at the Georgian-Russian border crossing points',
  dataStatus: 'Data Status',
  notAvailable: 'Not Available',
  refreshRates: 'Refresh Rates',
  failedToFetchRates: 'Failed to fetch rates',
  queueStatus: 'Queue Status',
  loadingQueueData: 'Loading queue data...',
  pageAutoRefreshes: 'Page auto-refreshes every 3 minutes',
  tryChangingFilters: 'Try changing filters or refresh the page',
  
     // Vehicle fleet to the 'en' translations object:
	 regVehicle: 'Register vehicle',
	 tractor: 'Tractor',
	 vehiclePassport: 'Vehicle passport',
	 driverPass: 'Driver passport',
	 hitched: 'Hitched to',
	 maxLoad: 'Max Load',
	 licPlateExam: 'e.g., 12AA345 or 12A345',
	 vinDesc: '17-character VIN',
	 vehPassDesc: 'Vehicle passport number',
	 vehYear: 'Year of issue',
     vehYearExam: 'e.g., 2008',
	 makeExam: 'e.g., Volvo, Man, Daf',
	 modelExam: 'e.g., FH16, TGX 18.480',
	 hitchTo: 'Hitch to',
	 trailerSelect: 'Select trailer',
	 alreadyHitched: 'Already hitched',
     netWeight: 'Net weight (kg)',
	 netWeightExam: 'e.g., 7500',
	 infoDriver: 'Driver information',
	 vehPassPhoto: 'Vehicle Passport Photos',
	 driverPassPhoto: 'Driver Passport Photo',
	 frontPhoto: 'Front photo',
	 backPhoto: 'Back photo',
	 
	 // Insurance page to the 'en' transactions object:
	 
	 getInsuranceGE: 'Get Georgian Insurance',
	 getInsuranceRU: 'Get Russian Insurance',
	 viewOrderedInsurances: 'View Ordered Insurances',
	 selectFrmVehFleet: 'Select from vehicle fleet',
	 semi_trailer: 'Semi-Trailer',
	 startDate: 'Start Date',
	 orderedInsurances: 'Ordered Insurances',
	 orderDate: 'Order date',
	 signed: 'Signed',
	 cannotDelete: 'Cannot delete',
	 cannotEdit: 'Cannot edit',
	 start: 'Start',
	 end: 'End',
	 policyNumber: 'Policy Number',
	 
	

	
	other: 'Other',

	 // --- Admin dashboard ---
	 statistics: 'Statistics',
	 finance: 'Finance',
	 accounting: 'Accounting',
	 noDocuments: 'No documents',
	 selectRecipients: 'Send to',
	 accountantRole: 'Accountant',
	 unsentAccountingInvoices: 'There are unsent invoices',
	 history: 'History',
	 action: 'Action',
	 object: 'Object',
	 changes: 'Changes',
	 allModels: 'All models',
	 allActions: 'All actions',
	 noHistory: 'No history',
	 statusProcessing: 'Processing',
	 onRoad: 'On Road',
	 completedToday: 'Completed Today',
	 expiring10d: 'Expiring (10d)',
	 expiredLabel: 'Expired',
	 unpaidPreorders: 'Unpaid pre-orders',
	 unsignedPreorders: 'Unsigned pre-orders',
	 last7days: 'last 7 days',
	 periodDay: 'Day',
	 periodWeek: 'Week',
	 periodMonth: 'Month',
	 period90days: '90 days',
	 period6months: '6 months',
	 periodYear: 'Year',
	 unsentTplInvoices: 'Unsent TPL GE invoices',
	 tplGeInvoices: 'TPL GE invoices',
	 send: 'Send',
	 recipients: 'Recipients',
	 russiaInsurance: 'Russia Insurance',
	 userCompany: 'User / Company',
	 qty: 'Qty',
	 noInvoices: 'No invoices',
	 leftSuffix: 'left',
	 exportToExcel: 'Export to Excel',
	 exportToPdf: 'Export to PDF',
	 pendingInvoices: 'Pending Invoices',
	 processingInvoices: 'Processing Invoices',
	 clickToViewList: 'Click to view list',
	 clickForDetails: 'Click for details',
	 clickForUserList: 'Click for user list',
	 processingRemainder: 'Processing — remainder',
	 totalLower: 'total',
	 allInvoices: 'All invoices',
	 payments: 'Payments',
	 unpaid: 'Unpaid',
	 advance: 'Advance',
	 allInvoicesBreakdown: 'All invoices — breakdown',
	 amdInvoices: 'AMD invoices',
	 gelInvoicesTts: 'GEL invoices (TTS Georgia)',
	 totalAmdNoVat: 'Total AMD (no VAT)',
	 totalAmdWithVat: 'Total AMD (with VAT)',
	 vat20: 'VAT 20%',
	 netAmountNoCommission: 'Net amount (no commission)',
	 totalGelLabel: 'Total GEL',
	 userAdvances: 'User advances',
	 user: 'User',
	 noAdvances: 'No advances',
	 allUsers: 'All users',
	 failedLoadStats: 'Failed to load stats.',
  },

  hy: {
    // Home/Landing Page
    companyName: 'Տրանսպորտ Տրանզիտ Սերվիս',
    companyNameShort: 'ՏՏՍ',
    home: 'Գլխավոր',
    heroTitle: 'Տրանսպորտային միջոցների գրանցում և ապահովագրություն',
    heroSubtitle: 'Պարզեցրեք Ձեր միջազգային փոխադրումները մեր կողմից առաջարկվող գրանցման և ապահովագրության  ծառայություններով։ Մենք մասնագիտանում ենք գտնելու արդյունավետ լուծումներ Վրաստան երթևեկող բոլոր տեսակի տրանսպորտային միջոցների համար։',
    learnMore: 'Իմանալ ավելին',
    getInsurance: 'Ստանալ ապահովագրություն',
    ourServices: 'Մեր ծառայությունները',
    servicesSubtitle: 'Մեր հարթակն առաջարկում է համալիր լուծումներ, որոնք մշակված են հատուկ միջազգային սահմանները (Վրաստան,Ռուսաստան) հատող տրանսպորտային ընկերությունների և անհատ վարորդների համար: Մեր փորձագիտական ուղեցույցի և արդյունավետ թվային գործիքների միջոցով մենք օգնում ենք Ձեզ հեշտությամբ կողմնորոշվել բարդ կանոնակարգերում:',
    registrationService: 'Տրանսպորտային միջոցների գրանցում',
    registrationServiceDesc: 'Մեր պարզեցված գրանցման համակարգը հնարավորություն է տալիս առցանց ձեռք բերել Վրաստանի ճանապարհային Տրանզիտ քարտեր, վճարել Վրաստանի Դարյալի կիրճում տեղակայված կայանատեղի գումարը՝  բեռնատար մեքենաների համար:',
    insuranceService: 'Ապահովագրություն',
    insuranceServiceDesc: 'Մեր օնլայն հարթակի միջոցով Վրաստանի Պարտադիր Ապահովագրության կենտրոնի հետ  կարող եք կնքել տրասպորտային միջոցի ապահովագրության պայմանագիր: Նախապես կնքելով պայմանագիրը Դուք զերծ եք մնում սահմանային անցակետում հերթերից և ժամանակի ավելորդ կորստից:',
    documentationService: 'Փաստաթղթեր',
    documentationServiceDesc: 'Հաղթահարեք տրանզիտային երթևեկության, բեռնափոխադրումների համար անհրաժեշտ պարտադիր վկայագրերի, քարտերի, թույլտվությունների ձեռքբերման բարդությունները մեր առցանց հարթակում առկա գործիքների միջոցով: Մեր մասնագետները կօգնեն Ձեզ արագ կողմնորոշվել տիրույթում:',
    readMore: 'Կարդալ ավելին',
    insuranceTitle: 'Ճանապարհորդեք վստահությամբ',
    insuranceHighlightDesc: 'Վրաստան ճամփորդելիս, պատշաճ ապահովագրություն ունենալը միայն  խորհուրդ չէ, այլ պահանջ է։ Մենք առաջարկում ենք Ձեր փոխարեն կնքել Վրաստանի օրենքներին  համապատասխանող տրանսպորտային միջոցի պարտադիր ապահովագրության վկայագիր (Պոլիս)՝ ձեր  ճանապարհորդությունը իրավախախտումներից զերծ պահելու համար.',
    insuranceBenefit1: 'Ակնթարթային էլեկտրոնային վկայագիր (պոլիս) — փաստաթուղթը անմիջապես ձեր էլ.փոստին, որը պարտադիր է տպել և ներկայացնել ըստ պահանջի,',
    insuranceBenefit2: 'Վավեր է Վրաստանի բոլոր իրավասու մարմինների և սահմանային հսկիչ կետերի կողմից,',
    insuranceBenefit3: 'Հարցերի և պահանջների դեպքում կարող եք դիմել մեր բազմալեզու տեխնիկական աջակցության թիմին։',
    getInsuranceNow: 'Ստանալ ապահովագրություն հիմա',
    registrationsCompleted: 'Կատարված գրանցումներ',
    insurancePoliciesIssued: 'Տրված ապահովագրական պոլիսներ',
    satisfactionRate: 'Հաճախորդների բավարարվածություն',
    supportAvailable: 'Հասանելի աջակցություն',
    contactCTA: 'Օգնության կարիք ունեք?',
    contactCTADesc: 'Մեր բազմալեզու թիմը պատրաստ է օգնել Ձեզ հարթակի միջոցով տրանսպորտային միջոցի գրանցման, ապահովագրության հարցում՝ անկախ ձեր գտնվելու վայրից։ Կապնվեք հեռախոսով, էլ.փոստով կամ չատով։',
    OurClients: 'Մեր հաճախորդների կարծիքները',
    Client1: '— Մարիա Կ., Լոգիստ Մենեջեր',
    Client2: '— Դավիթ Թ., Տրանսպորտային ընկերության տնօրեն',
    Client1Com: '"ՏՏՍ-ը հեղափոխել է մեր սահմանանցային գործունեությունը: Նրանց գրանցման արդյունավետ համակարգը և ապահովագրության արագ մշակումը խնայել է ժամանակը և կանխել սահմանային անցակետերում ուշացումները:"',
    Client2Com: '"Աջակցությունը բացառիկ է։ Երբ մենք խնդիր ունեցանք վրացական «Դարիալ» կայանատեղիում, նրանց թիմը լուծեց այն րոպեների ընթացքում:"',
    
    //PublicNavBar
    insuranceAM: 'Հայաստան',
    insuranceGE: 'Վրաստան',
    insuranceRU: 'Ռուսաստան',
    
    //PublicLayout
    servicesShortDesc: 'Մենք տրամադրում ենք համապարփակ ծառայություններ տրանսպորտային միջոցների համար:',
    LayoutServices: 'Ծառայություններ',
    LayoutRegistration: 'Գրանցումներ',
    LayoutInsurance: 'Ապահովագրություն',
    LayoutDocumentation: 'Փաստաթղթեր',
    LayoutConsultation: 'Խորհրդատվություն',
    LayoutSupport: 'Օգնություն',
    LayoutHelp: 'Օգնության կենտրոն',
    LayoutCont: 'Կապ մեզ հետ',
    LayoutFAQ: 'Հաճախ տրվող հարցեր',
    LayoutTerms: 'Օգտագործման պայմաններ',
    LayoutContact: 'Կապ',
    LayoutAddress1: 'Երևան,',
    LayoutAddress2: 'Հայաստան',
    LayoutPrivacy: 'Գաղտնիության քաղաքականություն',
    LayoutTerm: 'Պայմաններ',
    
    
    // Insurance Page
    vehicleInsurance: 'Տրանսպորտային միջոցների ապահովագրություն',
    vehicleInsuranceForGeorgia: 'Ապահովագրություն Վրաստան մեկնող տրանսպորտային միջոցների համար',
    insurancePageSubtitle: 'Պարտադիր ապահովագրություն Վրաստան մուտք գործող բոլոր տրանսպորտային միջոցների համար',
    insuranceFormSubtitle: 'Ստացեք Ձեր պոլիսը ընդամենը մի քանի րոպեում',
    duration: 'Ապահովագրության տևողություն',
    vehicleType: 'Տրանսպորտային միջոցի տեսակ',
    days: 'օր',
    days_15: '15 Օր',
    days_30: '30 Օր',
    days_90: '90 Օր',
	year_1: '1 տարի',
    year: '1 տարի',
    motorcycle: 'Մոտոցիկլ',
    passengerCar: 'Մարդատար ավտոմեքենա',
    bus: 'Ավտոբուս',
    truck: 'Բեռնատար',
    trailer: 'Կցորդ',
    specialVehicle: 'Հատուկ տրանսպորտային միջոց',
    insuranceCoverage: 'Ծածկույթի մանրամասներ',
    insuranceCoverageDesc: 'Այս ապահովագրությունը տրամադրում է երրորդ անձանց նկատմամբ պատասխանատվության ծածկույթ, ինչպես պահանջվում է վրացական օրենսդրությամբ',
    estimatedPrice: 'մոտավոր գին',
    manufacturer: 'Արտադրող',
    model: 'Մոդել',
    registrationNumber: 'Գրանցման համար',
    vinCode: 'VIN կոդ',
    frameNumber: 'Շրջանակի համար',
    personalDetails: 'Անձնական տվյալներ',
    firstName: 'Անուն',
    lastName: 'Ազգանուն',
    name: 'Անուն',
    idNumber: 'ID համար',
    email: 'Էլ. հասցե',
    review: 'Վերանայում և վճարում',
    totalAmount: 'Ընդհանուր գումար՝ ներառյալ ԱԱՀ (Դրամ)',
    totalPrice: 'Ընդհանուր գին',
    cardPayment: 'Քարտով վճարում',
    processing: 'Մշակվում է...',
    submitApplication: 'Ներկայացնել հայտը',
    allRightsReserved: 'Բոլոր իրավունքները պաշտպանված են',
    pleaseEnterCredentials: 'Խնդրում ենք մուտքագրել Ձեր օգտանունը և գաղտնաբառը',

    // Insurance Benefits and FAQ
    benefits: 'Առավելություններ',
    completeProtection: 'Լիարժեք պաշտպանություն',
    completeProtectionDesc: 'Ծածկույթ Վրաստանում բոլոր պատասխանատվության պահանջների համար',
    easyApplication: 'Հեշտ դիմում',
    easyApplicationDesc: 'Պարզ առցանց գործընթաց նվազագույն փաստաթղթավորմամբ',
    quickProcessing: 'Արագ մշակում',
    quickProcessingDesc: 'Ստացեք Ձեր ապահովագրական պոլիսը ընդամենը մի քանի րոպեում',
    georgiaWideAcceptance: 'Վրաստանում համատարած ընդունելություն',
    georgiaWideAcceptanceDesc: 'Վավեր է բոլոր սահմանային անցակետերում և ընդունված ամբողջ երկրում',
    faq: 'Հաճախակի տրվող հարցեր',
    faqCoverage: 'Ինչ է ծածկում ապահովագրությունը?',
    faqCoverageAnswer: 'Մեր ապահովագրությունը տրամադրում է երրորդ անձանց նկատմամբ պատասխանատվության ծածկույթ, ինչպես պահանջվում է վրացական օրենսդրությամբ երկիր մուտք գործող տրանսպորտային միջոցների համար։',
    faqDocuments: 'Ինչ փաստաթղթեր են անհրաժեշտ դիմելու համար?',
    faqDocumentsAnswer: 'Ձեզ անհրաժեշտ կլինի Ձեր տրանսպորտային միջոցի գրանցման վկայականը, անձը հաստատող փաստաթուղթը և տրանսպորտային միջոցի հիմնական տվյալները։',
    faqDuration: 'Կարող եմ երկարացնել ապահովագրության ժամկետը?',
    faqDurationAnswer: 'Այո, դուք կարող եք երկարացնել Ձեր ապահովագրությունը՝ դիմելով նոր պոլիսի համար նախքան ընթացիկ պոլիսի ժամկետի ավարտը։',
    faqProcessing: 'Որքան ժամանակ է պահանջվում իմ դիմումը մշակելու համար?',
    faqProcessingAnswer: 'Հայտերի մեծ մասը մշակվում է անմիջապես, և դուք կստանաք Ձեր պոլիսը էլ. փոստով մի քանի րոպեի ընթացքում։',
    insuranceDetailsInfo: 'Ապահովագրությունը պաշտպանություն է տրամադրում Ձեր տրանսպորտային միջոցին միջազգային սահմանները հատելիս։ Վավեր ապահովագրություն ունենալը պարտադիր է Վրաստան մուտք գործելիս։',
    editRegistration: 'Խմբագրել գրանցումը',
    update: 'Թարմացնել',

    // Auth
    login: 'Մուտք',
    username: 'Օգտանուն',
    password: 'Գաղտնաբառ',
    rememberMe: 'Հիշել ինձ',
    invalidCredentials: 'Անվավեր տվյալներ',
    loginFailed: 'Մուտքը ձախողվեց: Խնդրում ենք կրկին փորձել:',

    // Navigation
    registrations: 'Գրանցումներ',
	vehicleFleet: 'Ավտոպարկ',
    technicalConsultation: 'Տեխնիկական խորհրդատվություն',
    logout: 'Ելք',
    dashboard: 'Վահանակ',

    // Registration Form
    register: 'Գրանցել',
    exportExcel: 'Արտահանել Excel',
    export: 'Արտահանում',
    distribute: 'Բաշխել',
    exportToAccounting: 'Արտահանել հաշվապահություն',
    chooseExportType: 'Ընտրեք արտահանման տեսակը',
    extendedExport: 'Ընդլայնված արտահանում',
    extendedExportDesc: 'Ամսական գրանցումներ + ապահովագրություն + հաշիվ։',
    monthly: 'Ամսական',
    selectMonth: 'Ամիս',
    selectPlaceholder: '— ընտրել —',
    noAvailableMonths: 'Հասանելի ամիսներ դեռ չկան։',
    noDataMonth: 'տվյալներ չկան',
    loadingEllipsis: 'Բեռնվում է…',
    accUnavailAlready: 'Հաշվապահական արտահանումն անհասանելի է․ ամիսն արդեն արտահանվել է։',
    accUnavailPartly: 'Հաշվապահական արտահանումն անհասանելի է․ ամիսն արդեն մասամբ մշակված է։',
    vehicleDetails: 'Տրանսպորտային միջոցի տվյալներ',
    routeDetails: 'Երթուղու տվյալներ',
    insuranceDetails: 'Ապահովագրության տվյալներ',
    truckNumber: 'Մեքենայի համար',
    company: 'Ընկերություն',
    phone: 'Հեռախոս',
    ticket: 'Տոմս',
    entryPoint: 'Մուտքի կետ',
    exitPoint: 'Ելքի կետ',
    transitIn: 'Տարանցիկ քարտ',
    transitOut: 'Տարանցիկ ելք',
    transit: 'Տարանցիկ',
    status: 'Կարգավիճակ',
    insurance: 'ՏՄ Ապահովագրություն',
    departureDate: 'Մեկնման ամսաթիվ',
    terminalEntryDate: 'Տերմինալ մուտքի ամսաթիվ',
	terminalExitDate: 'Տերմինալ ելքի ամսաթիվ',
    dateFrom: 'Ամսաթվից',
    dateTo: 'Մինչ ամսաթիվը',
    search: 'Որոնել',
    reset: 'Չեղարկել',
    loading: 'Բեռնվում է...',
    save: 'Պահպանել',
    cancel: 'Չեղարկել',
    edit: 'Խմբագրել',
    delete: 'Ջնջել',
    yes: 'Այո',
    no: 'Ոչ',
    select: 'Ընտրել',
    nextStep: 'Հաջորդ քայլը',
    previousStep: 'Նախորդ քայլը',
	filters: 'Ֆիլտրեր',
	refresh: 'Թարմացնել',
	all: 'Բոլորը',
	searchFilters: 'Որոնման ֆիլտրեր',
	
	truckInsurance: 'Մեքենայի ապահովագրություն',
    trailerInsurance: '(Կիսա)Կցորդի ապահովագրություն',
    tirPark: 'TIR-կայանատեղի',
    service: 'Ծառայություն',
	trailerNumber: '(Կիսա)Կցորդի համար',
	transitAndComments: 'Տրանզիտ Քարտեր',
	comment: 'Մեկնաբանություն',
	driverInfo: 'Վարորդ',
	routeInfo: 'Ուղղություն',
	statusAndDate: 'Կարգավիճակ և Ամսաթիվ',
	daryal: 'Դարիալի Կիրճ',
	bagratashen: 'Բագրատաշեն',
	gogavan: 'Գոգավան',
    parking_40: 'Կայանատեղի Նատախտարի (40 լարի)',
    parking_80: 'Սահմանային կայանատեղիներ (80 լարի)',
    pending: 'Սպասում է մշակման',
	paid: 'Վճարված',
	unpaid: 'Չվճարված',
	no_need: 'Անհրաժեշտ չէ',
	on_road: 'Ճանապարհին',
	selectEntryExitPoints: 'Ընտրեք մուտքի և ելքի կետերը',
	selectEntryPoint: 'Ընտրեք մուտքի կետը',
	selectExitPoint: 'Ընտրեք ելքի կետը',
	fillNumber: 'Լրացրեք մեքենայի համարը',
	totalTransitRemain: 'Տրանզիտ քարտեր',
	parkDaryalRemain: 'Դարիալի կայանատեղի',
	parkBagrGogremain: 'Բագրատաշեն, Գոգավան կայանատեղիներ',
	truckInsuranceremain: 'Մեքենաների ապահովագրություն',
	trailerInsuranceremain: '(Կիսա)Կցորդների ապահովագրություն',
	registrationsremain: 'Մնացորդներ',
	murphy: 'Կազբեգ',
	IN: 'Պատվիրված',
	OUT: 'Տրված',
	Total: 'Ընդհանուր',
	transitIn_All: 'Պատվիրված Տրանզիտ քարտեր',
	transitOut_All: 'Տրված Տրանզիտ քարտեր',
	truck_insurance_All: 'Մեքենաների ապահովագրություն',
	trailer_insurance_All: '(Կիսա)Կցորդների ապահովագրություն',
	parking_40_All: 'Նատախտարի կայանատեղի',
	parking_entry_All: 'Դարիալի կայանատեղի',
	parking_exit_All: 'Բագրատաշեն, Գոգավան կայանատեղիներ',
	Registration_updated: 'Գրանցումը թարմացված է',
	Registration_created: 'Գրանցումը ստեղծված է',
	Registration_failed: 'Գրանցման խնդիր',

    // Admin registrations
    basicInfo: 'Հիմնական տեղեկություն',
    statusPoints: 'Կարգավիճակ & Կետեր',
    parkingsEntryExit: 'Կայաններ մուտք & ելք',
    transitInfo: 'Տրանզիտ տեղեկություն',
    exitPointEntryDate: 'Ելքի կետ — Մուտք',
    exitPointExitDate: 'Ելքի կետ — Ելք',
    natakhtariEntryDate: 'Նատախտարի — Մուտք',
    natakhtariExitDate: 'Նատախտարի — Ելք',
    bulkCreate: 'Խմբով ստեղծել',
    syncFromSite: 'Սինքրոնիզացիա',
    syncing: 'Սինքրոնիզացվում...',
    markCompleted: 'Նշել ավարտված',
    markCancelled: 'Նշել չեղարկված',
    noVehiclesFound: 'Ավտոպարկ դատարկ է',
    selectVehicleFirst: 'Ընտրեք մեքենան՝ մնացած դաշտերը լրացնելու համար։',
    vehicleNotInFleet: 'Այդ մեքենան ավտոպարկում չկա',
    insurancePeriods: 'Ապահովագրության ժամկետ',

    // Table
    registrationList: 'Գրանցումների ցանկ',
    totalRecords: 'Ընդհանուր գրառումներ',
    actions: 'Գործողություններ',
	totalRegistrations: 'Ընդհանուր գրանցումները',
	transitInOut: 'Տրանզիտ Քարտեր',

    // Status Options
    onRoad: 'Ճանապարհին',
    completed: 'Ավարտված',
    cancelled: 'Չեղարկված',
    
    // Contact/Consultation Page
    contactUs: 'Կապ մեզ հետ',
    howWeCanHelp: 'Ինչպես կարող ենք օգնել Ձեզ',
    helpRegistration: 'Տրանսպորտային միջոցների գրանցման աջակցություն',
    helpBorderCrossing: 'Տեխնիկական խորհրդակցություն սահմանային անցման ընթացակարգերի վերաբերյալ',
    helpDocumentation: 'Օգնություն պահանջվող փաստաթղթերի և թույլտվությունների հետ',
    helpLegalRequirements: 'Տեղեկատվություն իրավական պահանջների և կանոնակարգերի մասին',
    helpTechnicalIssues: 'Գրանցման համակարգի տեխնիկական խնդիրների աջակցություն',
    messagingApps: 'Հաղորդագրությունների հավելվածներ',
    
    // Invoices Page
    invoices: 'Հաշիվ-ապրանքագրեր',
    addInvoice: 'Ավելացնել հաշիվ',
    editInvoice: 'Խմբագրել հաշիվը',
    viewInvoice: 'Դիտել հաշիվը',
    invoiceId: 'Հաշվի ID',
    serviceType: 'Ծառայության տեսակ',
    transitCard: 'Տրանզիտային քարտ',
    quantity: 'Քանակ',
    price: 'Գին',
    paymentType: 'Վճարման եղանակ',
    cash: 'Կանխիկ',
    bankTransfer: 'Բանկային փոխանցում',
    card: 'Քարտ',
    attachFile: 'Կցել ֆայլ',
    selectFile: 'Ընտրել ֆայլը',
    changeFile: 'Փոխել ֆայլը',
    downloadFile: 'Ներբեռնել ֆայլը',
    noFilesAttached: 'Ֆայլեր կցված չեն',
    markAsPaid: 'Նշել որպես վճարված',
    paidTotal: 'Վճարված ընդհանուր',
    unpaidTotal: 'Չվճարված ընդհանուր',
    totalInvoices: 'Ընդհանուր հաշիվներ',
    transactions: 'Գործարքներ',
    noTransactions: 'Գործարքներ չեն գտնվել',
    amount: 'Գումար',
    saveFailed: 'Չհաջողվեց պահպանել հաշիվը',
    deleteFailed: 'Չհաջողվեց ջնջել հաշիվը',
    noInvoicesFound: 'Հաշիվներ չեն գտնվել',
    confirmDelete: 'Վստա՞հ եք, որ ցանկանում եք հեռացնել:',
	totalPaid: 'Ընդհանուր վճարված է',
	totalUnpaid: 'Չվճարված է',
	exchangeRates: 'Փոխարժեքներ',
	lastUpdated: 'Վերջին թարմացումը',
	invoicesList: 'Հաշիվ-ապրանքագրերի ցանկ',
	invoiceNumber: 'Համար',
	date: 'Ամսաթիվ',
	payment: 'Վճարում',
	paidServiceQuantities: 'Վճարված ծառայությունների ընդհանուր քանակություն',
    activePaidTotal: 'Ընդհանուր վճարված',
	activeUnpaidTotal: 'Ընդհանուր չվճարված',  
	serviceDetails: 'Ծառայության մանրամասներ',
	enter_quantity: 'Մուտքագրեք քանակը',
	commission: 'Միջնորդավճար',
	paymentInformation: 'Վճարման մասին տեղեկատվություն',
	attachment: 'Կցել ֆայլ',
	dragAndDropFile: 'Տեղափոխել ֆայլը այստեղ',
	browseFiles: 'Բեռնել ֆայլը',
	or: 'կամ',
    transactionsWillAppearHere: 'Գործարքները կհայտնվեն այստեղ',
	transactionsDescription: 'Գործարքի մանրամասներ',
	totalAmountGEL: 'Ընդհանուր գումար (Լարի)',
	required: 'Պարտադիր',   
	pleaseFixErrors: 'Լրացրեք պարտադիր դաշտերը',
	fixedPriceService: 'Ֆիքսված գնով ծառայություն',
	view: 'Դիտել',
	invoiceNotPendingNoEdit: 'Խմբագրել հնարավոր է մինչ մշակումը',
	invoiceNotPendingNoDelete: 'Հեռացնել հնարավոր է մինչ մշակումը',
	close: 'Փակել',
	download: 'Ներբեռնել',
	invoiceUpdated: 'Թարմացված է',
	invoiceCreated: 'Ստեղծված է',
	saveInvoiceError: 'Չի պահպանվել',
    confirmDeleteInvoice: 'Հաստատեք հեռացումը',
	deleteInvoiceError: 'Հեռացման խնդիր',
	fetchInvoiceError: 'Ինվոյսի ստացման խնդիր',
	paymentStatus: 'Վճարման կարգավիճակ',
	exportSuccess: 'Արտահանված է',
	exportFailed: 'Չհաջողված արտահանում',

  // Notification-related translations
  notifications: 'Ծանուցումներ',
  selected: 'ընտրված',
  selectAll: 'Ընտրել բոլորը',
  clearSelection: 'Չեղարկել ընտրությունը',
  markAsRead: 'Նշել որպես կարդացված',
  markAllAsRead: 'Բոլորը նշել որպես կարդացված',
  bulkMarkAsRead: 'Ընտրվածները նշել որպես կարդացված',
  bulkDelete: 'Ջնջել ընտրվածները',
  confirmBulkDelete: 'Վստա՞հ եք, որ ցանկանում եք ջնջել ընտրված ծանուցումները:',
  noNotifications: 'Ծանուցումներ չկան',
  notificationsWillAppearHere: 'Ծանուցումները կհայտնվեն այստեղ',
  justNow: 'Հենց նոր',
  ago: 'առաջ',
  loadMore: 'Բեռնել ավելին',
  
  // System notification translations
  registrationCreated: 'Գրանցումը ստեղծված է',
  registrationUpdated: 'Գրանցումը թարմացված է',
  registrationDeleted: 'Գրանցումը ջնջված է',
  registrationCreatedMsg: '{number} մեքենայի գրանցումը հաջողությամբ ստեղծվել է',
  registrationUpdatedMsg: '{number} մեքենայի գրանցման տվյալները թարմացվել են',
  registrationDeletedMsg: '{number} մեքենայի գրանցումը ջնջվել է',
  
  invoiceCreated: 'Հաշիվը ստեղծված է',
  invoiceUpdated: 'Հաշիվը թարմացված է',
  invoiceDeleted: 'Հաշիվը ջնջված է',
  invoicePaid: 'Հաշիվը վճարված է',
  invoiceCreatedMsg: '{invoiceNumber} հաշիվը {company} ընկերության համար ստեղծվել է',
  invoiceUpdatedMsg: '{invoiceNumber} հաշվի տվյալները թարմացվել են',
  invoiceDeletedMsg: '{invoiceNumber} հաշիվը ջնջվել է',
  
  transactionAdded: 'Գործարքը ավելացված է',
  
  insurance_signedMsg: '{plate_number} տրանսպորտային միջոցի պայմանագիրը կնքված է',
  insurance_signed: 'Պայմանագիրը կնքված է',
  insurance_expires: 'Ապահովագրության պայմանագրի ավարտի մասին հիշեցում',
  insurance_expiresMsg: '{plate_number} տրանսպորտային միջոցի ապահովագրությունը լրանում է {expireDays}.',
  today: 'այսօր',
  tomorrow: 'վաղը',
  notifDays: 'օրից',

  // In the 'hy' translations object, add:
  queueToRussia: 'Էլեկտրոնային հերթացուցակ',
  queueToRussiaDescription: 'Իրական ժամանակի տեղեկություններ Ռուսաստանում Վերին Լարսի անցակետի էլեկտրոնային հերթացուցակում տրանսպորտային միջոցների հերթերի մասին:',
  queueInformation: 'Հերթի տեղեկություններ',
  queueInfoTitle: 'Սահմանային հերթի կարգավիճակ',
  queueInfoDescription: 'Ընթացիկ հերթի տեղեկություններ վրացա-ռուսական սահմանում',
  autoRefreshInfo: 'Ավտոմատ թարմացում',
  minutes: 'րոպե',
  totalVehicles: 'Ընդամենը տրանսպորտային միջոցներ',
  licensePlate: 'Համարանիշ',
  location: 'Վայր',
  datetime: 'Ամսաթիվ և ժամ',
  number: 'Համար',
  dataSource: 'Տվյալների աղբյուր',
  noQueueData: 'Հերթի տվյալներ չկան',
  noQueueDataDescription: 'Հերթի տեղեկությունները ներկայումս հասանելի չեն: Խնդրում ենք փորձել թարմացնել կամ ետ դառնալ ավելի ուշ:',
  fetchingQueueData: 'Հերթի տվյալների ստացում...',
  failedToFetchQueueData: 'Հերթի տվյալները ստանալ չհաջողվեց: Խնդրում ենք փորձել ավելի ուշ:',
  georgianRussianBorder: 'Վրացա-ռուսական սահման',
  queueUnavailable: 'Հերթի տեղեկությունները ժամանակավորապես հասանելի չեն',
  timeToDelete: 'Ջնջման ժամանակ',
  actions: 'Գործողություններ',

  // Add these to the 'hy' translations object:
  dataStatus: 'Տվյալների կարգավիճակ',
  notAvailable: 'Հասանելի չէ',
  refreshRates: 'Թարմացնել փոխարժեքները',
  failedToFetchRates: 'Փոխարժեքները ստանալ չհաջողվեց',
  queueStatus: 'Հերթի կարգավիճակ',
  loadingQueueData: 'Հերթի տվյալների բեռնում...',
  pageAutoRefreshes: 'Էջը ավտոմատ թարմացնում է յուրաքանչյուր 3 րոպեում',
  tryChangingFilters: 'Փորձեք փոխել ֆիլտրերը կամ թարմացնել էջը',
  
      // Vehicle fleet to the 'en' translations object:
   regVehicle: 'Գրանցել ՏՄ',
   tractor: 'Քարշակ',
   vehiclePassport: 'Տեխ. անձնագիր',
   driverPass: 'Վարորդի անձնագիր',
   hitched: 'Կցված է',
   maxLoad: 'Առավելագույն բեռնում',
   licPlateExam: 'Օրինակ՝ 12AA345 կամ 12A345',
   vinDesc: '17 նիշանոց VIN',
     vehPassDesc: 'Տեխ. անձնագրի համարը',
	 vehYear: 'Թողարկման տարեթիվը',
    vehYearExam: 'Օրինակ՝ 2008',
    makeExam: 'Օրինակ՝ Volvo, Man, Daf',
    modelExam: 'Օրինակ՝ FH16, TGX 18.480',
	hitchTo: 'Կապել կցորդ',
	trailerSelect: 'Ընտրել կցորդ',
		 alreadyHitched: 'Արդեն կցված է',
		 netWeight: 'Զանգվածը առանց բեռնվածության (կգ)',
		 netWeightExam: 'Օրինակ՝ 7500',
		 infoDriver: 'Վարորդի մասին տեղեկություն',
	 vehPassPhoto: 'Տեխ. անձնագրի նկարներ',
	 driverPassPhoto: 'Վարորդի անձնագրի նկար',
	 frontPhoto: 'Առջևի էջի նկար',
	 backPhoto: 'Հետևի էջի նկար',

	 // Insurance page to the 'en' transactions object:
	 
	 getInsuranceGE: 'Կնքել Վրացական Ապահովագրություն',
	 getInsuranceRU: 'Կնքել Ռուսական Ապահովագրություն',
	 viewOrderedInsurances: 'Դիտել Պատվիրված Ապահովագրությունները',
	 	 selectFrmVehFleet: 'Ընտրել ավտոպարկից',
		 semi_trailer: 'Կիսակցորդ',
		 startDate: 'Սկիզբ',
		 orderedInsurances: 'Պատվիրված Ապահովագրություններ',
		 orderDate: 'Պատվերի ամսաթիվ',
		 signed: 'Կնքած է',
		 cannotDelete: 'Հնարավոր չէ հեռացնել',
		 cannotEdit: 'Հնարավոր չէ խմբագրել',
		 start: 'Սկիզբ',
		 end: 'Ավարտ',
		 policyNumber: 'Ապահովագրության համար',

		 
	
	other: 'Այլ',

	 // --- Admin dashboard ---
	 statistics: 'Վիճակագրություն',
	 finance: 'Ֆինանսներ',
	 accounting: 'Հաշվապահություն',
	 noDocuments: 'Փաստաթղթեր չկան',
	 selectRecipients: 'Ուղարկել ում',
	 accountantRole: 'Հաշվապահ',
	 unsentAccountingInvoices: 'Կան չուղարկված ինվոյսներ',
	 history: 'Պատմություն',
	 action: 'Գործողություն',
	 object: 'Օբյեկտ',
	 changes: 'Փոփոխություններ',
	 allModels: 'Բոլոր մոդելները',
	 allActions: 'Բոլոր գործողությունները',
	 noHistory: 'Պատմություն չկա',
	 statusProcessing: 'Մշակվում է',
	 onRoad: 'Ճանապարհին',
	 completedToday: 'Ավարտված այսօր',
	 expiring10d: 'Ավարտվում է (10 օր)',
	 expiredLabel: 'Ժամկետանց',
	 unpaidPreorders: 'Չվճարված նախնական',
	 unsignedPreorders: 'Չստորագրված նախնական',
	 last7days: 'վերջին 7 օրը',
	 periodDay: 'Օր',
	 periodWeek: 'Շաբաթ',
	 periodMonth: 'Ամիս',
	 period90days: '90 օր',
	 period6months: '6 ամիս',
	 periodYear: 'Տարի',
	 unsentTplInvoices: 'Չուղարկված TPL GE ինվոյսներ',
	 tplGeInvoices: 'TPL GE ինվոյսներ',
	 send: 'Ուղարկել',
	 recipients: 'Ստացողներ',
	 russiaInsurance: 'Ռուսաստանի ապահովագրություն',
	 userCompany: 'Օգտատեր / Ընկերություն',
	 qty: 'Քանակ',
	 noInvoices: 'Ինվոյսներ չկան',
	 leftSuffix: 'մնաց',
	 exportToExcel: 'Արտահանել Excel',
	 exportToPdf: 'Արտահանել PDF',
	 pendingInvoices: 'Սպասող ինվոյսներ',
	 processingInvoices: 'Մշակվող ինվոյսներ',
	 clickToViewList: 'Սեղմեք ցուցակը տեսնելու համար',
	 clickForDetails: 'Սեղմեք մանրամասների համար',
	 clickForUserList: 'Սեղմեք օգտատերերի ցուցակի համար',
	 processingRemainder: 'Մշակվող — մնացորդ',
	 totalLower: 'ընդամենը',
	 allInvoices: 'Բոլոր ինվոյսները',
	 payments: 'Վճարումներ',
	 unpaid: 'Չվճարված',
	 advance: 'Կանխավճար',
	 allInvoicesBreakdown: 'Բոլոր ինվոյսները — մանրամասն',
	 amdInvoices: 'AMD ինվոյսներ',
	 gelInvoicesTts: 'GEL ինվոյսներ (TTS Georgia)',
	 totalAmdNoVat: 'Ընդ. AMD (առանց ԱԱՀ)',
	 totalAmdWithVat: 'Ընդ. AMD (ԱԱՀ-ով)',
	 vat20: 'ԱԱՀ 20%',
	 netAmountNoCommission: 'Զուտ գումար (առանց միջնորդավճարի)',
	 totalGelLabel: 'Ընդ. GEL',
	 userAdvances: 'Օգտատերերի կանխավճարներ',
	 user: 'Օգտատեր',
	 noAdvances: 'Կանխավճարներ չկան',
	 allUsers: 'Բոլոր օգտատերերը',
	 failedLoadStats: 'Չհաջողվեց բեռնել վիճակագրությունը։',
  },

  ru: {
    // Home/Landing Page
    companyName: 'Транспорт Транзит Сервис',
    companyNameShort: 'ТТС',
    home: 'Главная',
    heroTitle: 'Регистрация и страхование транспорта',
    heroSubtitle: 'Оптимизируйте международные перевозки – наши услуги регистрации и страхования для всех видов транспорта в Грузии помогут вам сэкономить время и избежать сложностей.',
    learnMore: 'Узнать больше',
    getInsurance: 'Получить страховку',
    ourServices: 'Наши услуги',
    servicesSubtitle: 'Наша платформа предлагает комплексные решения, разработанные специально для транспортных компаний и частных водителей, пересекающих международные границы (Грузия, Россия). С нашей экспертной поддержкой и цифровыми инструментами вы легко справитесь даже с самыми сложными требованиями законодательства.',
    registrationService: 'Регистрация транспорта',
    registrationServiceDesc: 'Наш упрощенный процесс регистрации позволит вам приобрести транзитные карты Грузии онлайн и оплатить парковку в ущелье Дарьяли для грузовиков.',
    insuranceService: 'Страхование',
    insuranceServiceDesc: 'С помощью нашей онлайн-платформы оформите обязательное страхование ответственности в Центре Обязательного Страхования Грузии. Оформив страховку заранее, вы избежите очередей при пересечении границы и лишней потери времени.',
    documentationService: 'Документация',
    documentationServiceDesc: 'Преодолейте сложности, связанные с получением обязательных транзитных разрешений, сертификатов и разрешений на трансграничные грузоперевозки, используя инструменты нашей онлайн-платформы. Наши эксперты помогут вам быстро сориентироваться в этой области.',
    readMore: 'Подробнее',
    insuranceTitle: 'Путешествуйте с уверенностью',
    insuranceHighlightDesc: 'При поездке в Грузию наличие соответствующей страховки - не просто рекомендация, а требование. Мы предлагаем оформить полис обязательного страхования транспортного средства в соответствии со всеми грузинскими правилами, чтобы ваше путешествие прошло без юридических осложнений.',
    insuranceBenefit1: 'Мгновенное оформление полиса в цифровом формате - получите документы сразу же по электронной почте (которые вы должны распечатать и предоставить по требованию)',
    insuranceBenefit2: 'Признается всеми грузинскими властями и пограничными пунктами',
    insuranceBenefit3: 'Многоязычная служба поддержки для ваших претензии или вопросов',
    getInsuranceNow: 'Получить страховку сейчас',
    registrationsCompleted: 'Выполненных регистраций',
    insurancePoliciesIssued: 'Выданных страховых полисов',
    satisfactionRate: 'Удовлетворенность клиентов',
    supportAvailable: 'Доступная поддержка',
    contactCTA: 'Нужна помощь?',
    contactCTADesc: 'Наши многоязычные специалисты готовы помочь вам с регистрацией и страхованием транспортных средств через нашу платформу - независимо от того, где вы находитесь. Получите квалифицированную помощь по электронной почте или в чате.',
    OurClients: 'Что говорят наши клиенты',
    Client1: '— Мариа К., Менеджер по логистике',
    Client2: '— Давид Т., Владелец транспортной компании',
    Client1Com: '"ТТС произвела революцию в наших трансграничных операциях. Их эффективная система регистрации и быстрая обработка страховки сэкономили нам бесчисленное количество часов и предотвратили задержки на пограничных переходах."',
    Client2Com: '"Поддержка исключительная. Когда у нас возникла проблема на грузинском парковочном терминале Дариали, их команда решила ее за считанные минуты."',
    
    //PublicNavBar
    insuranceAM: 'Армения',
    insuranceGE: 'Грузия',
    insuranceRU: 'Россия',
    
    //PublicLayout
    servicesShortDesc: 'Мы оказываем комплексные услуги для транспортных средств.',
    LayoutServices: 'Услуги',
    LayoutRegistration: 'Регистрация',
    LayoutInsurance: 'Страхование',
    LayoutDocumentation: 'Документация',
    LayoutConsultation: 'Консультация',
    LayoutSupport: 'Помощь',
    LayoutHelp: 'Центр поддержки',
    LayoutCont: 'Связь с нами',
    LayoutFAQ: 'Часто задаваемые вопросы',
    LayoutTerms: 'Условия использования',
    LayoutContact: 'Контакты',
    LayoutAddress1: 'Ереван,',
    LayoutAddress2: 'Армения',
    LayoutPrivacy: 'Конфиденциальность',
    LayoutTerm: 'Условия',
    
    
    // Insurance Page
    vehicleInsurance: 'Страхование транспортных средств',
    vehicleInsuranceForGeorgia: 'Страхование для поездок в Грузию',
    insurancePageSubtitle: 'Обязательное страхование для всех транспортных средств, въезжающих в Грузию',
    insuranceFormSubtitle: 'Получите ваш полис всего за несколько минут',
    duration: 'Срок страхования',
    vehicleType: 'Тип транспортного средства',
    days: 'дней',
    days_15: '15 Дней',
    days_30: '30 Дней',
    days_90: '90 Дней',
	year_1: '1 год',
    year: '1 год',
    motorcycle: 'Мотоцикл',
    passengerCar: 'Легковой автомобиль',
    bus: 'Автобус',
    truck: 'Грузовик',
    trailer: 'Прицеп',
    specialVehicle: 'Специальный транспорт',
    insuranceCoverage: 'Детали покрытия',
    insuranceCoverageDesc: 'Эта страховка обеспечивает покрытие ответственности перед третьими лицами в соответствии с законодательством Грузии',
    estimatedPrice: 'ориентировочная цена',
    manufacturer: 'Производитель',
    model: 'Модель',
    registrationNumber: 'Регистрационный номер',
    vinCode: 'VIN-код',
    frameNumber: 'Номер рамы',
    personalDetails: 'Личные данные',
    firstName: 'Имя',
    lastName: 'Фамилия',
    name: 'Имя',
    idNumber: 'Номер ID',
    email: 'Эл. почта',
    review: 'Проверка и оплата',
    totalAmount: 'Общая сумма с НДС (Драм)',
    totalPrice: 'Итоговая цена',
    cardPayment: 'Кредитная/дебетовая карта',
    processing: 'Обработка...',
    submitApplication: 'Отправить заявку',
    allRightsReserved: 'Все права защищены',
    pleaseEnterCredentials: 'Пожалуйста, введите имя пользователя и пароль',

    // Insurance Benefits and FAQ
    benefits: 'Преимущества',
    completeProtection: 'Полная защита',
    completeProtectionDesc: 'Покрытие всех требований ответственности в Грузии',
    easyApplication: 'Простое оформление',
    easyApplicationDesc: 'Простой онлайн-процесс с минимальным количеством документов',
    quickProcessing: 'Быстрая обработка',
    quickProcessingDesc: 'Получите страховой полис всего за несколько минут',
    georgiaWideAcceptance: 'Признание по всей Грузии',
    georgiaWideAcceptanceDesc: 'Действует на всех пограничных переходах и принимается по всей стране',
    faq: 'Часто задаваемые вопросы',
    faqCoverage: 'Что покрывает страховка?',
    faqCoverageAnswer: 'Наша страховка обеспечивает покрытие ответственности перед третьими лицами в соответствии с законодательством Грузии для транспортных средств, въезжающих в страну.',
    faqDocuments: 'Какие документы нужны для оформления?',
    faqDocumentsAnswer: 'Вам понадобится свидетельство о регистрации транспортного средства, документ, удостоверяющий личность, и основные сведения о транспортном средстве.',
    faqDuration: 'Могу ли я продлить срок страхования?',
    faqDurationAnswer: 'Да, вы можете продлить страховку, подав заявку на новый полис до истечения срока действия текущего.',
    faqProcessing: 'Сколько времени занимает обработка моей заявки?',
    faqProcessingAnswer: 'Большинство заявок обрабатываются немедленно, и вы получите полис по электронной почте в течение нескольких минут.',
    insuranceDetailsInfo: 'Страхование обеспечивает защиту вашего транспортного средства при пересечении международных границ. Наличие действительной страховки является обязательным при въезде в Грузию.',
    editRegistration: 'Редактировать регистрацию',
    update: 'Обновить',

    // Auth
    login: 'Вход',
    username: 'Имя пользователя',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    invalidCredentials: 'Неверные учетные данные',
    loginFailed: 'Ошибка входа. Пожалуйста, попробуйте снова.',

    // Navigation
    registrations: 'Регистрации',
	vehicleFleet: 'Автопарк',
    technicalConsultation: 'Техническая консультация',
    logout: 'Выход',
    dashboard: 'Панель управления',

    // Registration Form
    register: 'Зарегистрировать',
    exportExcel: 'Экспорт в Excel',
    export: 'Экспорт',
    distribute: 'Распределить',
    exportToAccounting: 'Экспорт в бухгалтерию',
    chooseExportType: 'Выберите тип экспорта',
    extendedExport: 'Расширенный экспорт',
    extendedExportDesc: 'Месячные регистрации + страховки + счёт.',
    monthly: 'Помесячно',
    selectMonth: 'Месяц',
    selectPlaceholder: '— выбрать —',
    noAvailableMonths: 'Пока нет доступных месяцев.',
    noDataMonth: 'нет данных',
    loadingEllipsis: 'Загрузка…',
    accUnavailAlready: 'Экспорт в бухгалтерию недоступен: месяц уже выгружен.',
    accUnavailPartly: 'Экспорт в бухгалтерию недоступен: месяц уже частично проведён.',
    vehicleDetails: 'Данные транспортного средства',
    routeDetails: 'Данные маршрута',
    insuranceDetails: 'Данные страховки',
    truckNumber: 'Номер машины',
    company: 'Компания',
    phone: 'Телефон',
    ticket: 'Билет',
    entryPoint: 'Пункт въезда',
    exitPoint: 'Пункт выезда',
    transitIn: 'Транзитная карта',
    transitOut: 'Транзит выход',
    transit: 'Транзит',
    status: 'Статус',
	murphy: 'Казбеги',
    insurance: 'Страховка ТС ',
    departureDate: 'Дата отправления',
    terminalEntryDate: 'Дата въезда в терминал',
	terminalExitDate: 'Дата выезда из терминала',
    dateFrom: 'Дата с',
    dateTo: 'Дата до',
    search: 'Поиск',
    reset: 'Сброс',
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отменить',
    edit: 'Редактировать',
    delete: 'Удалить',
    yes: 'Да',
    no: 'Нет',
    select: 'Выбрать',
    nextStep: 'Следующий шаг',
    previousStep: 'Предыдущий шаг',
	truckInsurance: 'Страховка машины',
    trailerInsurance: 'Страховка (Полу)Прицепа',
    tirPark: 'TIR-Стоянка',
    service: 'Услуга',
	trailerNumber: 'Номер (Полу)Прицепа',
	transitAndComments: 'Транзитные Карты',
	comment: 'Коментарии',
	driverInfo: 'Водитель',
	routeInfo: 'Направленив',
	statusAndDate: 'Статус и Дата',
	daryal: 'Дарьяльское ущелье',
	bagratashen: 'Садахло',
	gogavan: 'Гугути',
	parking_40: 'Стоянка Натахтари (40 лари)',
    parking_80: 'Стоянки у границ (80 лари)',
	pending: 'В ожидании',
	paid: 'Оплачено',
	unpaid: 'Не оплачено',
	filters: 'Фильтры',
	refresh: 'Обновить',
	all: 'Все',
	searchFilters: 'Фильтры поиска',
	no_need: 'Не нужно',
	on_road: 'В дороге',
	selectEntryExitPoints: 'Выберите пункты въезда и выезда',
	selectEntryPoint: 'Выберите пункт въезда',
	selectExitPoint: 'Выберите пункт выезда',
	fillNumber: 'Заполните номер машины',
	totalTransitRemain: 'Транзитные карты',
	parkDaryalRemain: 'Парковка Дарьяли',
	parkBagrGogremain: 'Парковки Баграташен,Гогаван',
	truckInsuranceremain: 'Страхование машины',
	trailerInsuranceremain: 'Страхование (Полу)Прицепа',
	registrationsremain: 'Остатки',
	IN: 'Заказано',
	OUT: 'Выдано',
	Total: 'Общее',
	transitIn_All: 'Заказанные Транзитные карты',
	transitOut_All: 'Выданные Транзитные карты',
	truck_insurance_All: 'Страховки машин',
	trailer_insurance_All: 'Страховки (Полу)Прицепа',
	parking_40_All: 'Парковка Натахтари',
	parking_entry_All: 'Парковка Дарьяли',
	parking_exit_All: 'Парковки Баграташен,Гогаван',
	Registration_updated: 'Регистрация обновлено',
	Registration_created: 'Регистрация создано',
	Registration_failed: 'Ошибка регистрации',

    // Admin registrations
    basicInfo: 'Основная информация',
    statusPoints: 'Статус и точки',
    parkingsEntryExit: 'Стоянки въезд & выезд',
    transitInfo: 'Транзитная информация',
    exitPointEntryDate: 'Пункт выезда — Въезд',
    exitPointExitDate: 'Пункт выезда — Выезд',
    natakhtariEntryDate: 'Натахтари — Въезд',
    natakhtariExitDate: 'Натахтари — Выезд',
    bulkCreate: 'Массовое создание',
    syncFromSite: 'Синхронизация',
    syncing: 'Синхронизация...',
    markCompleted: 'Отметить завершёнными',
    markCancelled: 'Отметить отменёнными',
    noVehiclesFound: 'Транспорта нет в автопарке',
    selectVehicleFirst: 'Сначала выберите машину, чтобы разблокировать остальные поля.',
    vehicleNotInFleet: 'Такой машины нет в автопарке',
    insurancePeriods: 'Периоды страхования',

    // Table
    registrationList: 'Список регистраций',
    totalRecords: 'Всего записей',
    actions: 'Действия',
	totalRegistrations: 'Всего регистраций',
	transitInOut: 'Транзитные Карты',

    // Status Options
    onRoad: 'В пути',
    completed: 'Завершено',
    cancelled: 'Отменено',
    
    // Contact/Consultation Page
    contactUs: 'Связаться с нами',
    howWeCanHelp: 'Как мы можем вам помочь',
    helpRegistration: 'Помощь в регистрации транспортных средств',
    helpBorderCrossing: 'Техническая консультация по процедурам пересечения границы',
    helpDocumentation: 'Помощь с необходимой документацией и разрешениями',
    helpLegalRequirements: 'Информация о правовых требованиях и правилах',
    helpTechnicalIssues: 'Поддержка по техническим вопросам системы регистрации',
    messagingApps: 'Приложения для обмена сообщениями',
    
    // Invoices Page
    invoices: 'Счета-фактуры',
    addInvoice: 'Добавить счет',
    editInvoice: 'Редактировать счет',
    viewInvoice: 'Просмотр счета',
    invoiceId: 'Номер счета',
    serviceType: 'Тип услуги',
    transitCard: 'Транзитная карта',
    quantity: 'Количество',
    price: 'Цена',
    paymentType: 'Способ оплаты',
    cash: 'Наличные',
    bankTransfer: 'Банковский перевод',
    card: 'Карта',
    attachFile: 'Прикрепить файл',
    selectFile: 'Выбрать файл',
    changeFile: 'Изменить файл',
    downloadFile: 'Скачать файл',
    noFilesAttached: 'Файлы не прикреплены',
    markAsPaid: 'Отметить как оплаченный',
    paidTotal: 'Всего оплачено',
    unpaidTotal: 'Всего не оплачено',
    totalInvoices: 'Всего счетов',
    transactions: 'Транзакции',
    noTransactions: 'Транзакции не найдены',
    amount: 'Сумма',
    saveFailed: 'Не удалось сохранить счет',
    deleteFailed: 'Не удалось удалить счет',
    noInvoicesFound: 'Счета не найдены',
    confirmDelete: 'Вы уверены, что хотите удалить?',
	totalPaid: 'Всего оплачено',
	totalUnpaid: 'Не оплачено',
	exchangeRates: 'Курсы обмена',
	lastUpdated: 'Последнее обновление',
	invoicesList: 'Список счетов-фактур',
	invoiceNumber: 'Номер',
	date: 'Дата',
	payment: 'Оплата',
	paidServiceQuantities: 'Общее количество оплаченных услуг',
	activePaidTotal: 'Всего оплачено',
	activeUnpaidTotal: 'Всего неоплачено',
	serviceDetails: 'Детали услуги',
	enter_quantity: 'Вводите количество',
	commission: 'Комиссия',
	paymentInformation: 'Информация о платеже',
	attachment: 'Прикрепить файл',
	dragAndDropFile: 'Перетащить файл',
	browseFiles: 'Просмотреть файлы',
	or: 'или',
	transactionsWillAppearHere: 'Транзакции будут отображаться здесь',
	transactionsDescription: 'Детали транзакции',
	totalAmountGEL: 'Общая сумма (Лари)',
	required: 'Обязательно',
	pleaseFixErrors: 'Заполните обязательные поля',
	fixedPriceService: 'Услуга с фиксированной ценой',
	view: 'Смотреть',
	invoiceNotPendingNoEdit: 'Редактирование возможно в статусе Ожидании',
	invoiceNotPendingNoDelete: 'Удалить возможно в статусе Ожидании',
	close: 'Закрыть',
	download: 'Скачать',
	invoiceUpdated: 'Обновлено',
	invoiceCreated: 'Создано',
	saveInvoiceError: 'Не сохранено',
	confirmDeleteInvoice: 'Подвердите удаление',
	deleteInvoiceError: 'Ошибка удаления',
	fetchInvoiceError: 'Ошибка получения инвойса',
	paymentStatus: 'Статус оплаты',
	exportSuccess: 'Экспортировано',
	exportFailed: 'Не удачный экспорт',

  // Notification-related translations
  notifications: 'Уведомления',
  selected: 'выбрано',
  selectAll: 'Выбрать все',
  clearSelection: 'Очистить выбор',
  markAsRead: 'Отметить как прочитанное',
  markAllAsRead: 'Отметить все как прочитанные',
  bulkMarkAsRead: 'Отметить выбранные как прочитанные',
  bulkDelete: 'Удалить выбранные',
  confirmBulkDelete: 'Вы уверены, что хотите удалить выбранные уведомления?',
  noNotifications: 'Нет уведомлений',
  notificationsWillAppearHere: 'Уведомления будут отображаться здесь',
  justNow: 'Только что',
  ago: 'назад',
  loadMore: 'Загрузить еще',
  
  // System notification translations
  registrationCreated: 'Регистрация создана',
  registrationUpdated: 'Регистрация обновлена',
  registrationDeleted: 'Регистрация удалена',
  registrationCreatedMsg: 'Регистрация для машины {number} успешно создана',
  registrationUpdatedMsg: 'Данные регистрации для машины {number} обновлены',
  registrationDeletedMsg: 'Регистрация для машины {number} удалена',
  
  invoiceCreated: 'Счет создан',
  invoiceUpdated: 'Счет обновлен',
  invoiceDeleted: 'Счет удален',
  invoicePaid: 'Счет оплачен',
  invoiceCreatedMsg: 'Счет {invoiceNumber} для {company} создан',
  invoiceUpdatedMsg: 'Данные счета {invoiceNumber} обновлены',
  invoiceDeletedMsg: 'Счет {invoiceNumber} удален',
  
  insurance_signedMsg: 'Для транспортного средства {plate_number} страховка заключена',
  insurance_signed: 'Страховка заключена',
  insurance_expires: 'Напоминание о закончивании страховки',
  insurance_expiresMsg: 'Страховка {plate_number} транспортного средства заканчивается {expireDays}.',
  today: 'сегодня',
  tomorrow: 'завтра',
  notifDays: 'дней',
  through: 'через',
  
  transactionAdded: 'Транзакция добавлена',

  // In the 'ru' translations object, add:
  queueToRussia: 'Электронная очередь',
  queueToRussiaDescription: 'Информация об очередях транспортных средств в электронной очереди на КПП «Верхний Ларс» в России в режиме реального времени',
  queueInformation: 'Информация об очереди',
  queueInfoTitle: 'Статус очереди на границе',
  queueInfoDescription: 'Текущая информация об очереди на грузино-российской границе',
  autoRefreshInfo: 'Авто-обновление',
  minutes: 'минут',
  totalVehicles: 'Всего транспортных средств',
  licensePlate: 'Номерной знак',
  location: 'Местоположение',
  datetime: 'Дата и время',
  number: 'Номер',
  dataSource: 'Источник данных',
  noQueueData: 'Нет данных об очереди',
  noQueueDataDescription: 'Информация об очереди в настоящее время недоступна. Попробуйте обновить или проверить позже.',
  fetchingQueueData: 'Получение данных очереди...',
  failedToFetchQueueData: 'Не удалось получить данные очереди. Попробуйте позже.',
  georgianRussianBorder: 'Грузино-российская граница',
  queueUnavailable: 'Информация об очереди временно недоступна',
  timeToDelete: 'Время до удаления',
  actions: 'Действия',

    // Add these to the 'ru' translations object:
  realTimeQueueInfo: 'Информация в реальном времени об очередях транспортных средств на пунктах пересечения грузино-российской границы',
  dataStatus: 'Статус данных',
  notAvailable: 'Недоступно',
  refreshRates: 'Обновить курсы',
  failedToFetchRates: 'Не удалось получить курсы',
  queueStatus: 'Статус очереди',
  loadingQueueData: 'Загрузка данных очереди...',
  pageAutoRefreshes: 'Страница автоматически обновляется каждые 3 минуты',
  tryChangingFilters: 'Попробуйте изменить фильтры или обновить страницу',
  
     // Vehicle fleet to the 'en' translations object:
  regVehicle: 'Зарегистрировать ТС',
  tractor: 'Тягач',
  vehiclePassport: 'Тех. паспорт',
  driverPass: 'Паспорт водителя',
  hitched: 'Прицеплен',
  maxLoad: 'Макс. загрузка',
  licPlateExam: 'Пример: 12AA345 или 12A345',
  vinDesc: '17 символьный VIN',
  vehPassDesc: 'Номер тех. паспорта',
  vehYear: 'Год производства',
  vehYearExam: 'Пример: 2008',
  makeExam: 'Пример: Volvo, Man, Daf',
  modelExam: 'Пример: FH16, TGX 18.480',
  hitchTo: 'Связать прицеп',
  trailerSelect: 'Выбрать прицеп',
  alreadyHitched: 'Уже прицеплен',
  netWeight: 'Масса без груза (кг)',
  netWeightExam: 'Пример: 7500',
  infoDriver: 'Информация о водителе',
  vehPassPhoto: 'Фото тех. паспорта',
  driverPassPhoto: 'Фото паспорта водителя',
  frontPhoto: 'Фото спереди',
  backPhoto: 'Фото сзади',
  
	 // Insurance page to the 'en' transactions object:
	 
	 getInsuranceGE: 'Получить Грузинскую Страховку',
	 getInsuranceRU: 'Получить Российскую Страховку',
	 viewOrderedInsurances: 'Смотреть Заказанные Страховки',
	 	 selectFrmVehFleet: 'Выбрать из автопарка',
		 semi_trailer: 'Полуприцеп',
		 startDate: 'Дата начала',
		 orderedInsurances: 'Заказанные Страховки',
		 orderDate: 'Дата заказа',
		 signed: 'Заключено',
		 cannotDelete: 'Невозможно удалить',
		 cannotEdit: 'Неважно редактировать',
		 start: 'Начало',
		 end: 'Конец',
		 policyNumber: 'Номер Страховки',

  	
	other: 'Другое',

	 // --- Admin dashboard ---
	 statistics: 'Статистика',
	 finance: 'Финансы',
	 accounting: 'Бухгалтерия',
	 noDocuments: 'Нет документов',
	 selectRecipients: 'Кому отправить',
	 accountantRole: 'Бухгалтер',
	 unsentAccountingInvoices: 'Есть неотправленные инвойсы',
	 history: 'История',
	 action: 'Действие',
	 object: 'Объект',
	 changes: 'Изменения',
	 allModels: 'Все модели',
	 allActions: 'Все действия',
	 noHistory: 'Нет истории',
	 statusProcessing: 'В обработке',
	 onRoad: 'В пути',
	 completedToday: 'Завершено сегодня',
	 expiring10d: 'Истекает (10д)',
	 expiredLabel: 'Истекло',
	 unpaidPreorders: 'Неоплаченные предзаказы',
	 unsignedPreorders: 'Неподписанные предзаказы',
	 last7days: 'последние 7 дней',
	 periodDay: 'День',
	 periodWeek: 'Неделя',
	 periodMonth: 'Месяц',
	 period90days: '90 дней',
	 period6months: '6 месяцев',
	 periodYear: 'Год',
	 unsentTplInvoices: 'Неотправленные TPL GE инвойсы',
	 tplGeInvoices: 'TPL GE инвойсы',
	 send: 'Отправить',
	 recipients: 'Получатели',
	 russiaInsurance: 'Страховка Россия',
	 userCompany: 'Юзер / Компания',
	 qty: 'Кол-во',
	 noInvoices: 'Нет инвойсов',
	 leftSuffix: 'осталось',
	 exportToExcel: 'Экспорт в Excel',
	 exportToPdf: 'Экспорт в PDF',
	 pendingInvoices: 'Инвойсы в ожидании',
	 processingInvoices: 'Инвойсы в обработке',
	 clickToViewList: 'Нажми чтобы посмотреть список',
	 clickForDetails: 'Нажми для деталей',
	 clickForUserList: 'Нажми для списка юзеров',
	 processingRemainder: 'В обработке — остаток',
	 totalLower: 'всего',
	 allInvoices: 'Все инвойсы',
	 payments: 'Оплаты',
	 unpaid: 'Не оплачено',
	 advance: 'Аванс',
	 allInvoicesBreakdown: 'Все инвойсы — разбивка',
	 amdInvoices: 'AMD инвойсы',
	 gelInvoicesTts: 'GEL инвойсы (TTS Georgia)',
	 totalAmdNoVat: 'Итого AMD (без VAT)',
	 totalAmdWithVat: 'Итого AMD (с VAT)',
	 vat20: 'VAT 20%',
	 netAmountNoCommission: 'Чистая сумма (без комиссии)',
	 totalGelLabel: 'Итого GEL',
	 userAdvances: 'Авансы юзеров',
	 user: 'Юзер',
	 noAdvances: 'Нет авансов',
	 allUsers: 'Все пользователи',
	 failedLoadStats: 'Не удалось загрузить статистику.',
  }
};

export const LanguageProvider = ({ children }) => {
 const [language, setLanguage] = useState(() => {
   return localStorage.getItem('language') || 'en';
 });

 useEffect(() => {
   localStorage.setItem('language', language);
 }, [language]);

 const value = {
   language,
   setLanguage,
   translations,
   t: (key) => translations[language][key] || key,
 };

 return (
   <LanguageContext.Provider value={value}>
     {children}
   </LanguageContext.Provider>
 );
};

export const useLanguage = () => {
 const context = useContext(LanguageContext);
 if (context === undefined) {
   throw new Error('useLanguage must be used within a LanguageProvider');
 }
 return context;
};